import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faCaretDown, faCaretRight } from "@fortawesome/pro-regular-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../providers/AuthContext";
import useExporter from "../../hooks/useExporter";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import toast from "react-hot-toast";
import LoadingTablePage from "../LoadingTablePage";
import Breadcrumbs from "../../components/Breadcrumbs";
import TableView from "../../components/TableView";
import { format } from "date-fns";
import { getBillingHistoryDetailsByBillingHistory } from "../../api/BillingGroups";
import priceFormatter from "../../helpers/PriceFormater";
import BillingSummaryCard from "../../components/historybilling/BillingSummaryCard";

const HistoryBillingPage = () => {
  const { exportMultipleSheets } = useExporter();
  const { billingHistoryPublicId } = useParams();
  const { getAccessToken } = useAuth();
  const [selectedBillingRows, setSelectedBillingRows] = useState([]);
  const [selectedUserRows, setSelectedUserRows] = useState([]);
  const [selectedLicenseRows, setSelectedLicenseRows] = useState([]);
  const [selectedDomainRows, setSelectedDomainRows] = useState([]);
  const [selectedProductRows, setSelectedProductRows] = useState([]);
  const [selectedIndexRows, setSelectedIndexRows] = useState([]);
  const [historyUsers, setHistoryUsers] = useState([]);
  const [historyBillings, setHistoryBillings] = useState([]);
  const [historyLicenses, setHistoryLicenses] = useState([]);
  const [historyDomains, setHistoryDomains] = useState([]);
  const [historyproducts, setHistoryproducts] = useState([]);
  const [historyIndexAdjustments, setHistoryIndexAdjustments] = useState([]);
  const [discrepancies, setDiscrepancies] = useState([]);

  const [billingData, setBillingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expandedAccountType, setExpandedAccountType] = useState(null);
  const navigate = useNavigate();

  const invoicingPeriod = billingData?.summary?.invoicingPeriod ?? billingData?.billing?.type;
  const isQuarterly = invoicingPeriod?.toLowerCase() === "quarterly";

  useEffect(() => {
    const fetchBillingHistoryDetails = async () => {
      try {
        const accessToken = await getAccessToken();
        const data = await getBillingHistoryDetailsByBillingHistory(
          billingHistoryPublicId,
          accessToken
        );

        console.log("Data från API:", data);

        if (data) {
          setHistoryBillings([
            {
              historyDate: data.date,
              billingGroupName: data.billingGroupName,
              price: priceFormatter(data.total),
              subject: data.billing.subject,
              startDate: data.billing.fromDate,
              endDate: data.billing.toDate,
              updatedBy: data.updatedBy ? data.updatedBy.name : "unedited",
              updatedDate: data.updatedDateTimeUTC,
            },
          ]);

          data?.usersSummary?.forEach(user => {
            user.price = priceFormatter(user.price);
            user.totalPrice = priceFormatter(user.totalPrice);
          });

          data?.licensesSummary?.forEach(license => {
            license.price = priceFormatter(license.price);
            license.totalPrice = priceFormatter(license.totalPrice);
          });

          data?.addOnServiceSummary?.forEach(services => {
            services.price = priceFormatter(services.price);
            services.totalPrice = priceFormatter(services.totalPrice);
          });
          
          data?.domains?.forEach(domains => {
            domains.price = priceFormatter(domains.price);
          });

          data?.discrepancies?.forEach(discrepancie => {
            discrepancie.price = priceFormatter(discrepancie.price);
            discrepancie.totalPrice = priceFormatter(discrepancie.totalPrice);
          });

          setHistoryUsers(data.usersSummary || []);
          setHistoryLicenses(data.licensesSummary || []);
          setHistoryproducts(data.productsSummary || []);
          setHistoryDomains(data.domains || []);
          setHistoryIndexAdjustments(data.indexAdjustmentsSummary || []);
          setDiscrepancies(data.discrepancies || []);
          setBillingData(data);
        }
      } catch (error) {
        console.error("Failed to fetch billing history details:", error);
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBillingHistoryDetails();
  }, [billingHistoryPublicId, getAccessToken]);

  const handleExportToExcel = (data, sheetName) => {
    if (!data || data.length === 0) {
      toast.error("No data to export");
      return;
    }
    const billingGroupName = data[0]?.billingGroupName || "Unknown";
    const currentDate = format(new Date(), "yyyy-MM-dd");

    let formattedData = [
      { Users: billingData.users || [] },
      { Licenses: billingData.licensesSummary || [] },
      { Add_on_services: historyproducts || [] },
      { Domains: historyDomains || [] },
      { Index: historyIndexAdjustments || [] },
      { Post_adjustments: discrepancies?.map((d) => ({ type: d.type, name: d.name, months: d.numberOfMonths, totalPrice: d.totalPrice })) || [] },
    ];

    const filename = `Billing_${billingGroupName}_${currentDate}`;

    console.log(`Exporting ${sheetName}:`, data);   
    
    exportMultipleSheets(formattedData, filename);

  };
  
  const handleBackClick = () => {
    navigate(-1);
  };

  const getTitle = () => {
    console.log("History Billings:", historyBillings);
    if (historyBillings[0]) {
      return `${historyBillings[0].billingGroupName} ${historyBillings[0].startDate?.split('T')[0]} - ${historyBillings[0].endDate?.split('T')[0]}`;
    }
    return "Billing history";
  }

  console.log("Rendered Licenses:", historyLicenses);

  return (
    <>
      <HeaderBar />
      <div className="flex flex-col">
        <div className="flex flex-row">
          <Sidebar />
          <main className="page">
            <div className="absolute w-full pointer-events-none">
              <LoadingTablePage title={"Billingname"} loading={loading} />
            </div>
            <div className={`${loading ? "loading" : ""} page-content`}>
              <Breadcrumbs />
              <div>
                <div className="flex flex-col pb-4">
                  <div className="flex flex-row items-center pb-4 justify-between">
                    <div className="flex flex-row items-center">
                      <button
                        onClick={handleBackClick}
                        className="text-black flex"
                      >
                        <FontAwesomeIcon
                          icon={faArrowLeftLong}
                          className="w-4 pr-4"
                        />
                      </button>
                      <h2 className="border-l border-mute-200 pl-4 text-2xl text-black font-bold">
                        {getTitle()}
                      </h2>
                    </div>
                    <button
                      className="btn-outline-primary-small"
                      onClick={() =>
                        handleExportToExcel(historyBillings, "BillingHistory")
                      }
                    >
                      Export Billing History
                    </button>
                  </div>
                </div>
              </div>
              <div className="">
                <div className="border rounded-md shadow-md p-4 mb-4">

                  <TableView
                    data={historyBillings}
                    selectedRows={selectedBillingRows}
                    setSelectedRows={setSelectedBillingRows}
                    showActions={false}
                    disableLink={true}
                    noCheckbox={true}
                    columns={[
                      { key: "historyDate", label: "History date" },
                      { key: "billingGroupName", label: "Billing group name" },
                      { key: "price", label: isQuarterly ? "Price per quarter" : "Price per month" },
                      { key: "subject", label: "Subject" },
                      { key: "startDate", label: "Start date" },
                      { key: "endDate", label: "End date" }
                    ]}
                    primaryKey="billingHistoryPublicId" //CHANGE ID!
                  />
                </div>
                {billingData?.summary && (
                  <BillingSummaryCard
                    summary={billingData.summary}
                    total={billingData.total}
                    isQuarterly={isQuarterly}
                    indexAdjustments={historyIndexAdjustments}
                  />
                )}
                <div className="border rounded-md shadow-md p-4 mb-4">

                  <div className="flex flex-row justify-between items-center">
                    <h2 className="mb-2">Users</h2>
                  </div>
                  <table className="w-full text-sm text-left">
                    <thead>
                      <tr className="border-b text-gray-600">
                        <th className="py-2 px-3 w-8"></th>
                        <th className="py-2 px-3">Billing group name</th>
                        <th className="py-2 px-3">Account type</th>
                        <th className="py-2 px-3">Price (monthly)</th>
                        <th className="py-2 px-3">Count</th>
                        <th className="py-2 px-3">Total price (monthly)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {historyUsers.map((row, idx) => (
                        <React.Fragment key={idx}>
                          <tr
                            className="border-b hover:bg-blue-50 cursor-pointer"
                            onClick={() =>
                              setExpandedAccountType(
                                expandedAccountType === row.accountTypeName
                                  ? null
                                  : row.accountTypeName
                              )
                            }
                          >
                            <td className="py-2 px-3">
                              <FontAwesomeIcon
                                icon={expandedAccountType === row.accountTypeName ? faCaretDown : faCaretRight}
                                className="text-gray-500"
                              />
                            </td>
                            <td className="py-2 px-3">{row.billingGroupName}</td>
                            <td className="py-2 px-3">{row.accountTypeName}</td>
                            <td className="py-2 px-3">{row.price}</td>
                            <td className="py-2 px-3">{row.count}</td>
                            <td className="py-2 px-3">{row.totalPrice}</td>
                          </tr>
                          {expandedAccountType === row.accountTypeName && (
                            <tr>
                              <td colSpan={6} className="p-0">
                                <div className="bg-gray-50 p-4">
                                  <h3 className="text-sm font-semibold mb-2">
                                    {row.accountTypeName}
                                  </h3>
                                  <TableView
                                    data={
                                      (billingData?.users || []).filter(
                                        (u) => u.accountTypeName === row.accountTypeName
                                      )
                                    }
                                    selectedRows={[]}
                                    setSelectedRows={() => {}}
                                    showActions={false}
                                    disableLink={true}
                                    noCheckbox={true}
                                    columns={[
                                      { key: "displayName", label: "Name" },
                                      { key: "userPrincipalName", label: "Email" },
                                      { key: "price", label: "Price" },
                                      { key: "billingGroupName", label: "Billing group" },
                                    ]}
                                    primaryKey="userId"
                                  />
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="border rounded-md shadow-md p-4 mb-4">

                  <div className="flex flex-row justify-between items-center">
                    <h2 className="mb-2">Licenses</h2>

                  </div>
                  <TableView
                    data={historyLicenses}
                    selectedRows={selectedLicenseRows}
                    setSelectedRows={setSelectedLicenseRows}
                    showActions={false}
                    disableLink={true}
                    noCheckbox={true}
                    columns={[
                      { key: "billingGroupName", label: "Billing group name" },
                      { key: "name", label: "License name" },
                      { key: "unitPrice", label: "Unit price (monthly)" },
                      { key: "count", label: "Count" },
                      { key: "totalPrice", label: "Total price (monthly)" },
                    ]}
                    primaryKey="price" //CHANGE ID!
                  />
                </div>

                <div className="border rounded-md shadow-md p-4 mb-4">
                  <div className="flex flex-row justify-between items-center">
                    <h2 className="mb-2">Domains</h2>
                  </div>
                  <TableView
                    data={historyDomains}
                    selectedRows={selectedDomainRows}
                    setSelectedRows={setSelectedDomainRows}
                    showActions={false}
                    disableLink={true}
                    noCheckbox={true}
                    columns={[
                      { key: "billingGroupName", label: "Billing group name" },
                      { key: "name", label: "Domain name" },
                      { key: "price", label: "Price (monthly)" },
                    ]}
                    primaryKey="nameSRSItemId" //CHANGE ID!
                  />
                </div>

                <div className="border rounded-md shadow-md p-4 mb-4">
                  <div className="flex flex-row justify-between items-center">
                    <h2 className="mb-2">Add-on services</h2>
                  </div>
                  <TableView
                    data={historyproducts}
                    selectedRows={selectedProductRows}
                    setSelectedRows={setSelectedProductRows}
                    showActions={false}
                    disableLink={true}
                    noCheckbox={true}
                    columns={[
                      { key: "billingGroupName", label: "Billing group name" },
                      { key: "name", label: "Add-on service name" },
                      { key: "price", label: "Price (monthly)" },
                      { key: "count", label: "Count" },
                      { key: "totalPrice", label: "Total price (monthly)" },
                    ]}
                    primaryKey="count" //CHANGE ID!
                  />
                </div>
                <div className="border rounded-md shadow-md p-4 mb-4">
                  <div className="flex flex-row justify-between items-center">
                    <h2 className="mb-2">Indexes</h2>
                  </div>
                  <TableView
                    data={historyIndexAdjustments}
                    selectedRows={selectedIndexRows}
                    setSelectedRows={setSelectedIndexRows}
                    showActions={false}
                    disableLink={true}
                    noCheckbox={true}
                    columns={[
                      { key: "name", label: "Name" },
                      { key: "indexFactor", label: "Index" },
                    ]}
                    primaryKey="name" //CHANGE ID!
                  />
                </div>
                <div className="border rounded-md shadow-md p-4 mb-4">
                  <div className="flex flex-row justify-between items-center">
                    <h2 className="mb-2">Post adjustments</h2>
                  </div>
                  <TableView
                    data={discrepancies}
                    selectedRows={selectedIndexRows}
                    setSelectedRows={setSelectedIndexRows}
                    showActions={false}
                    disableLink={true}
                    noCheckbox={true}
                    columns={[
                      { key: "type", label: "Type" },
                      { key: "name", label: "Name" },
                      { key: "numberOfMonths", label: "Months" },
                      { key: "totalPrice", label: "Total Price" },
                    ]}
                    primaryKey="name" //CHANGE ID!
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default HistoryBillingPage;
